import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';
import { formatDate } from '~/common';

const Component = (props) => {
    const getClassName = (note) => {
        let className = 'context-menu';
        if (props.selectedNote && props.selectedNote.id === note.id) {
            className += ' selected';
        }
        return className;
    };

    // noinspection JSUnresolvedVariable,JSValidateTypes
    return (
        <TableContainer>
            <Table>
                <TableHead><TableRow>
                    <TableCell className="offer">Оффер</TableCell>
                    <TableCell className="date">Дата</TableCell>
                    <TableCell>Тема</TableCell>
                    {/*<TableCell>Заметка</TableCell>*/}
                </TableRow></TableHead>
                <TableBody>
                    {props.notes.map((note) => (
                        <TableRow key={note.id} className={getClassName(note)}
                                  onContextMenu={props.onContextMenu(note)}
                        >
                            <TableCell className="offer">
                                <Link to={`/offers/${note.offer.offer_name}/`}>{note.offer.offer_name}</Link>
                            </TableCell>
                            <TableCell className="date">{ formatDate(new Date(note.datetime))}</TableCell>
                            <TableCell>{note.subject}</TableCell>
                            {/*<TableCell dangerouslySetInnerHTML={{__html: note.note_truncated}}/>*/}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

Component.propTypes = {
    notes: PropTypes.array.isRequired,
    selectedNote: PropTypes.object,
    onContextMenu: PropTypes.func.isRequired,
};

export default Component;
